import { Header } from '@lightspeed/design-system-react'
import { VendImage } from '@vend/react-utilities'
import React, { FC } from 'react'
import { useT } from '@transifex/react'
import { LSPAYModalContent } from './LSPAYModalContent'

export const Processing: FC = () => {
  const t = useT()

  return (
    <LSPAYModalContent>
      <VendImage
        relativeImagePath="payments/processing-refund-v1.svg"
        relativeDarkImagePath="payments/processing-refund-darkmode-v1.svg"
      />
      <Header type={'heading'} level="2">
        {t('Processing refund', {
          _context: 'Processing refund modal header',
        })}
      </Header>
    </LSPAYModalContent>
  )
}
